<section class="mat-typography">
    <h1><u>Your Report File History</u> <span class="material-icons pull-right pointer red-text bold" (click)="closeDialog(false);">close</span></h1>
</section>
<div class="text-center">
    <tools-table
        [Headers]="headers"
        #profileFilesTable
        [Search]="true"
        [Actions]="Actions"
        [SortColumn]="'Timestamp'"
        [Desc]="true"
        [ApiPath]="URL"
        [Slim]="true"
        [DynamicCount]="true"
        [RefreshConfig]="tableRefreshConfig"
        [DisplayCount]="10">
    </tools-table>
    <br />
</div>